import React, { ChangeEvent, useEffect, useState } from 'react';

interface Props {
  id: string;
  label: string;
  type: 'tel' | 'text' | 'number' | 'email' | 'password' | 'date';
  disabled?: boolean;
  required?: boolean;
  defaultValue?: string;
  maxLength?: number;
  placeholder?: string;
  rows?: number;
  onChange: (
    e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>
  ) => void;
  pattern?: string;
  width?: string;
  multiline?: boolean;
  autoComplete?: string;
  description?: string;
  hint?: string;
  error?: string | null;
  cy?: string;
  marginBottom?: string | null;
  padding?: string | null;
}

const InputField: React.FC<Props> = ({
  id,
  label,
  type,
  disabled,
  required,
  maxLength,
  defaultValue,
  placeholder,
  rows,
  onChange,
  pattern,
  width,
  multiline,
  autoComplete,
  description,
  hint,
  error,
  cy,
  marginBottom,
  padding,
}) => {
  const [value, setValue] = useState(defaultValue ?? '');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onChange(e);
  };

  const handleChange2 = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
    onChange(e);
  };

  useEffect(() => {
    setValue(defaultValue ?? '');
  }, [defaultValue]);

  return (
    <React.Fragment>
      <div className="form-wrapper">
        <div className="form-group">
          <label htmlFor={id}>
            {label} {required ? '*' : ''}
          </label>
          {description && <p>{description}</p>}
          {multiline ? (
            <textarea
              name={id}
              id={id}
              disabled={disabled}
              maxLength={maxLength}
              value={value}
              rows={rows}
              onChange={(e) => handleChange2(e)}
              placeholder={placeholder}
            />
          ) : (
            <input
              data-cy={cy}
              type={type}
              name={id}
              id={id}
              disabled={disabled}
              maxLength={maxLength}
              value={value}
              pattern={pattern}
              onChange={(e) => handleChange(e)}
              placeholder={placeholder}
              autoComplete={autoComplete}
            />
          )}
          {hint && <p>{hint}</p>}
        </div>
        <div className="error">{error}</div>
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .form-wrapper {
          margin-bottom: ${marginBottom ?? '1rem'};
        }

        .form-group {
          /*border-bottom: 1px solid #707070;*/
          box-sizing: border-box;
          position: relative;
          width: ${width ?? '300px'};
        }

        .form-group label {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 16px;
          transition: all 100ms ease-in-out;
          cursor: default;
        }

        .form-group input[type='tel'],
        .form-group input[type='text'],
        .form-group input[type='number'],
        .form-group input[type='password'],
        .form-group input[type='email'],
        .form-group input[type='date'],
        .form-group textarea {
          font-family: 'Volvo Novum', sans-serif;
          background: transparent;
          border-color: #707070;
          border-width: 1px;
          font-size: 14px;
          outline: 0;
          padding: ${padding ?? '0.25rem 0 0.5rem'};
          width: 100%;
        }

        .error {
          font-family: 'Volvo Novum', sans-serif;
          color: red;
        }

        p {
          font-family: 'Volvo Novum', sans-serif;
          margin: 0 0 6px;
          font-size: 14px;
          font-weight: 400;
        }
      `}</style>
    </React.Fragment>
  );
};

export default InputField;
